import { Box, SxProps } from '@mui/material';

type Props = {
  sx?: SxProps;
};

const Logo = ({ sx }: Props) => (
  <Box sx={{ width: 240, ...sx }} component="img" src="/logo_black.webp" alt="FireMenu logo" />
);

export default Logo;
